var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("link", {
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-custom-link"
  }), /*#__PURE__*/React.createElement("link", {
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  }), /*#__PURE__*/React.createElement("style", {
    lang: "en",
    type: "text/css",
    id: "dark-mode-custom-style"
  }), /*#__PURE__*/React.createElement("style", {
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-style"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.22,20.2l-4.32-4.36a.19.19,0,0,0-.17-.07.24.24,0,0,0-.17.08L21.68,18.9a2,2,0,0,1-1.45.63h0a2,2,0,0,1-1.45-.63L12.6,12.31a.24.24,0,0,0-.32,0l-9.62,7.5L1.42,18.2,11,10.7a2.23,2.23,0,0,1,3,.24l6.17,6.59,2.86-3.05a2.22,2.22,0,0,1,1.6-.71,2.18,2.18,0,0,1,1.62.66l4.32,4.36Z",
    fill: "#aaaaaa",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.08,31H4.92A3.92,3.92,0,0,1,1,27.08V4.92A3.92,3.92,0,0,1,4.92,1H27.08A3.92,3.92,0,0,1,31,4.92V27.08A3.92,3.92,0,0,1,27.08,31ZM4.92,3A1.92,1.92,0,0,0,3,4.92V27.08A1.92,1.92,0,0,0,4.92,29H27.08A1.92,1.92,0,0,0,29,27.08V4.92A1.92,1.92,0,0,0,27.08,3Z",
    fill: "#aaaaaa",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.33,
    cy: 9.83,
    r: 2,
    fill: "#aaaaaa",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,19.5l9.53-7.67,1.76-.21,5.77,6.16s1,1.37,1.85.43l2.87-3.05s.57-1.25,1.79,0S30,20.5,30,20.5l-.07,7.23S29.63,30,26.69,30s-22-.31-22-.31S2,30.35,2,27.08,2,19.5,2,19.5Z",
    fill: "#aaaaaa",
    "data-original": "#000000",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.094a633d871b57733f2ddcaba1cb9ca0.svg";
export { ForwardRef as ReactComponent };